import { defineStore } from 'pinia';
import { api } from '@/services/http.service';
import { PspTagListPayload } from '@/models/psp-tag/psp-tag-list.model';
import { PspTagItem } from '@/models/psp-tag/psp-tag.model';
import { DEFAULT_LIMIT, DEFAULT_OFFSET } from '@/models/constants';
import { ResponseHeaders } from '@/models/app-internal/headers.model';
import { showErrorNotification } from '@/utils/show-notification.util';

interface PspTagListStore {
  isPspTagListLoading: boolean;
  pspTagList: PspTagItem[];
  limit: number;
  offset: number;
  currentPageNumber: number;
  listItemsCount: number;
}

export const usePspTagListStore = defineStore({
  id: 'PspTagListStore',
  state: (): PspTagListStore => ({
    isPspTagListLoading: false,
    pspTagList: [],
    limit: DEFAULT_LIMIT,
    offset: DEFAULT_OFFSET,
    currentPageNumber: 1,
    listItemsCount: 0,
  }),
  actions: {
    setPspTagListLoading(isLoading: boolean): void {
      this.isPspTagListLoading = isLoading;
    },
    setLimit(limit: number): void {
      this.limit = limit;
    },
    setOffset(offset: number): void {
      this.offset = offset;
    },
    setCurrentPageNumber(page: number): void {
      this.currentPageNumber = page;
    },
    setListItemsCount(count: number): void {
      this.listItemsCount = count;
    },
    processResponseHeaders(headers: Record<string, string>): void {
      const listItemsCount = Number(headers[ResponseHeaders.LIST_ITEMS_COUNT_HEADER]);

      if (isNaN(listItemsCount) || listItemsCount < 0) {
        return;
      }

      this.setListItemsCount(listItemsCount);
    },
    getPspTagList(): Promise<PspTagItem[]> {
      this.setPspTagListLoading(true);

      const requestPayload: PspTagListPayload = {
        offset: this.offset,
        limit: this.limit,
      };

      return api.pspTag.getPspTagListRequest.perform(requestPayload)
        .then(({ data, headers }) => {
          this.pspTagList = data;

          this.processResponseHeaders(headers);

          return data;
        }).catch(error => {
          showErrorNotification(error);

          return [];
        })
        .finally(() => {
          this.setPspTagListLoading(false);
        });
    },
  },
});
